import React from 'react';

import './SellDeductionsReviewRow.scss';

import { SELL_DEDUCTION_REVIEW_MODAL } from 'src/redux/modules/modals/modals.module';
import ModalLink from 'src/components/Shared/Modal/ModalLink/ModalLink';
import { currency } from '../../../../utils/utils';

const SellDeductionsReviewRow = ({
  selectedFunds,
  sellTotalAmount,
  sellTotalDeduction,
}) => (
  <div className="e2e-sell-deductions-row sell-deduction-review-row">
    {selectedFunds.length > 1 && (
      <div>
        <div className="col-md-9 col-xs-6 sell-deduction-review-row-sub-total">
          Subtotal:
        </div>
        <div className="col-md-3 col-xs-6 sell-deduction-review-row-amount">
          {currency(sellTotalAmount)}
        </div>
      </div>
    )}
    <div>
      <div className="col-md-9 col-xs-6 sell-deduction-review-row-total-deductions">
        <ModalLink
          link="Total Deductions"
          linkStyle="dashed"
          modalName={SELL_DEDUCTION_REVIEW_MODAL}
          modalProps={{ selectedFunds }}
        />
      </div>
      <div className="col-md-3 col-xs-6 sell-deduction-review-row-total-deductions-amount">
        -{currency(sellTotalDeduction)}
      </div>
    </div>
  </div>
);

export default SellDeductionsReviewRow;
